import classNames from 'classnames';

import css from './cms-block-title.css';

interface CMSBlockTitleProps {
  value: string;
  titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
}

export function CMSBlockTitle({ value, titleTag = 'h2', className }: CMSBlockTitleProps) {
  const TitleTag = titleTag;

  return <TitleTag className={classNames(css.title, className)}>{value}</TitleTag>;
}
